import { useState, useCallback, useEffect } from 'react';

export const useSwipeableModal = (onClose, threshold = 100) => {
	const [startY, setStartY] = useState(0);
	const [currentY, setCurrentY] = useState(0);
	const [dragging, setDragging] = useState(false);

	useEffect(() => {
		if (typeof onClose !== 'function') {
			console.error('useDraggableModal requires an onClose function');
		}
	}, [onClose]);

	const onTouchStart = useCallback((e) => {
		setStartY(e.touches[0].clientY);
		setCurrentY(0);
		setDragging(true);
	}, []);

	const onTouchMove = useCallback((e) => {
		if (dragging) {
			const touchCurrentY = e.touches[0].clientY;
			setCurrentY(touchCurrentY - startY);
		}
	}, [startY, dragging]);

	const onTouchEnd = useCallback(() => {
		setDragging(false);

		if (currentY > threshold) {
			if (onClose) onClose();
		}
		// Reset position
		setCurrentY(0);
	}, [currentY, onClose, threshold]);

	return {
		onTouchStart,
		onTouchMove,
		onTouchEnd,
		modalStyle: {
			transform: `translateY(${Math.max(0, currentY)}px)`,
			transition: dragging ? 'none' : 'transform 0.2s ease',
		},
	};
};
